import PolicyIcon from "@mui/icons-material/Policy";
import DownloadIcon from "@mui/icons-material/Download";
import { Box } from "@mui/material";
import { settings } from "app";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import { doctoralRequests } from "api/doctoralApi";
import AddDocumentDialog from "../../Partials/AddDocumentDialog";
import { ArrayField, Datagrid, FunctionField, TextField, useNotify, useRecordContext } from "react-admin";
import { getFileFromUrl, previewFileFromUrl } from "server/components/DownloadFile";
import LoadingActionButton from "server/components/LoadingActionButton";

const DocumentSection = () => {
  const record = useRecordContext();
  const notify = useNotify();

  if (!record?.id) return null;

  const documentRows = record.documents.flatMap(group =>
    (group.documentIds ?? []).map(documentId => ({
      id: documentId,
      name: group.name,
      documentId,
    })),
  );

  const fileUrl = documentId => `${settings.gatewayApi}/document/private-documents/${documentId}`;

  return (
    <>
      <SecuredComponent permission={permissions.canUpdateDoctorants}>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
          <AddDocumentDialog url={doctoralRequests.addCandidacyDocument(record.id)} />
        </Box>
      </SecuredComponent>
    <ArrayField record={{ ...record, documentRows }} source="documentRows">
      <Datagrid rowClick={false} bulkActionButtons={false} sx={settings.style.secondaryDatagrid}>
        <FunctionField
          render={rec => (
            <>
              <LoadingActionButton
                label="Виж"
                icon={<PolicyIcon />}
                onClick={() => previewFileFromUrl(fileUrl(rec.documentId), `file-${rec.documentId}`, notify)}
              />
              <LoadingActionButton
                label="Изтегли"
                icon={<DownloadIcon />}
                onClick={() => getFileFromUrl(fileUrl(rec.documentId), `file-${rec.documentId}`, notify)}
              />
            </>
          )}
        />
        <TextField source="name" label="Документ" emptyText="-" sortable={false} />
      </Datagrid>
    </ArrayField>
    </>
  );
};

export default DocumentSection;
